import { useDurationContext } from "../contexts/DurationContext";
import { useAlertsParams } from "../hooks/useAlertsParams";

import { useEffectiveSelectedCompetitors } from "./filters/competitors/useEffectiveSelectedCompetitors";

interface IUseCommonAlertsQueryParamsOptions {
    /**
     * When true, only primary competitors are forwarded as `competitors`. Used by
     * SEO whose backend rejects secondary-domain entries.
     */
    primaryCompetitorsOnly?: boolean;
}

export const useCommonAlertsQueryParams = ({ primaryCompetitorsOnly = false }: IUseCommonAlertsQueryParamsOptions = {}) => {
    const { activationId } = useAlertsParams();
    const duration = useDurationContext();
    const { selectedCompetitorIds } = useEffectiveSelectedCompetitors({ primaryCompetitorsOnly });

    return {
        activationId,
        startDate: duration.forAPI.iso.from,
        endDate: duration.forAPI.iso.to,
        competitors: selectedCompetitorIds,
    };
};
